import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { Heart, Users, Book } from 'lucide-react';
import { missionSection } from '../mock/data';

const Mission = () => {
  return (
    <section className="py-16 lg:py-24 bg-gradient-to-br from-amber-50 to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Mission Content */}
          <div>
            <div className="mb-8">
              <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
                {missionSection.title}
              </h2>
              <p className="text-xl text-amber-600 font-semibold">
                {missionSection.subtitle}
              </p>
            </div>

            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p className="text-lg">
                {missionSection.story}
              </p>
              <p className="text-lg">
                {missionSection.description}
              </p>
              <p className="text-lg">
                {missionSection.belief}
              </p>
            </div>


          </div>

          {/* Mission Values Cards */}
          <div className="space-y-6">
            <Card className="bg-white shadow-md hover:shadow-lg transition-all duration-300 border-l-4 border-green-600">
              <CardContent className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4">
                    <Heart className="w-6 h-6 text-green-600" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">Ancestral Wisdom</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Honoring traditional knowledge and integrating it with modern technology to preserve and share ancestral practices.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-white shadow-md hover:shadow-lg transition-all duration-300 border-l-4 border-amber-600">
              <CardContent className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-amber-100 rounded-lg flex items-center justify-center mr-4">
                    <Users className="w-6 h-6 text-amber-600" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">Community Empowerment</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Building tools that strengthen Indigenous communities and help them exercise their sovereign rights and cultural identity.
                </p>
              </CardContent>
            </Card>

            <Card className="bg-white shadow-md hover:shadow-lg transition-all duration-300 border-l-4 border-blue-600">
              <CardContent className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                    <Book className="w-6 h-6 text-blue-600" />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900">Cultural Preservation</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">
                  Safeguarding Indigenous languages, traditions, and knowledge for future generations through secure digital archives.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;